export default function AboutHero() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/4afe9e75f6269f2fec0a1964ce4175c7.jpg')`
      }}
    >
      {/* 背景遮罩 */}
      <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/85 to-white/70"></div>
      
      <div className="relative z-10 w-full px-6 lg:px-32 max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* 左侧内容 */}
          <div className="text-left">
            <h1 className="text-3xl lg:text-7xl font-light text-gray-800 mb-6 lg:mb-8 leading-tight">
              关于
              <br />
              <span className="text-[#847eba]">燃轻元</span>
            </h1>
            
            <p className="text-sm lg:text-2xl text-gray-700 mb-6 lg:mb-8 font-light leading-relaxed">
              科学之下的轻松哲学
              <br />
              让体重管理成为一种快乐的生活方式
            </p>
            
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-4 lg:p-8 mb-8 lg:mb-12 shadow-lg border border-white/20">
              <p className="text-xs lg:text-lg text-gray-600 leading-relaxed font-light">
                我们深信，真正的改变源于内心的轻松与愉悦。
                <br />
                燃轻元不仅提供科学的产品解决方案，
                <br />
                更希望陪伴每个人找到属于自己的健康节奏。
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={() => {
                  const storySection = document.getElementById('brand-story');
                  if (storySection) {
                    storySection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="inline-flex items-center justify-center px-6 lg:px-10 py-3 lg:py-4 bg-[#847eba] text-white hover:bg-[#6b5d9a] transition-all duration-300 rounded-full text-sm lg:text-base font-medium whitespace-nowrap cursor-pointer group shadow-lg"
              >
                探索品牌故事
                <i className="ri-arrow-down-line ml-2 group-hover:translate-y-1 transition-transform duration-300"></i>
              </button>
              
              <button 
                onClick={() => window.REACT_APP_NAVIGATE('/')}
                className="inline-flex items-center justify-center px-6 lg:px-10 py-3 lg:py-4 border-2 border-[#847eba] text-[#847eba] hover:bg-[#847eba] hover:text-white transition-all duration-300 rounded-full text-sm lg:text-base font-medium whitespace-nowrap cursor-pointer"
              >
                返回首页
              </button>
            </div>
          </div>

          {/* 右侧装饰区域 */}
          <div className="hidden lg:flex justify-center items-center">
            <div className="relative">
              <div className="absolute -top-8 -left-8 w-16 h-16 border-l-2 border-t-2 border-[#847eba]/20 rounded-tl-lg"></div>
              <div className="absolute -bottom-8 -right-8 w-16 h-16 border-r-2 border-b-2 border-[#a3c1c3]/20 rounded-br-lg"></div>
              <div className="absolute top-4 right-4 w-2 h-2 bg-[#847eba]/30 rounded-full"></div>
              <div className="absolute bottom-4 left-4 w-3 h-3 bg-[#a3c1c3]/30 rounded-full"></div>
              
              <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-12 shadow-2xl border border-white/40">
                <div className="text-center">
                  <div className="w-24 h-24 bg-gradient-to-br from-[#847eba] to-[#a3c1c3] rounded-full flex items-center justify-center mb-6">
                    <i className="ri-heart-3-line text-3xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-medium text-gray-800 mb-2">轻松一点</h3>
                  <p className="text-gray-600 font-light">才轻一点</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}